import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./HeadMenu.css";

const HeadMenu = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const [mobileOpen, setMobileOpen] = useState(false);
    const menuRef = useRef(null);

    const toggleDropdown = (menu) => {
        setOpenDropdown(openDropdown === menu ? null : menu);
    };

    const closeMenu = () => {
        setOpenDropdown(null);
        setMobileOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                closeMenu();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <nav className={`headmenu${mobileOpen ? " is-open" : ""}`} ref={menuRef} aria-label="Main Navigation">
            <Link className="brand" to="/" onClick={closeMenu}>
                <img src="/pictures/wisdom-mark.svg" alt="" />
                <span className="brand-copy">
                    <strong>Wisdom Academy</strong>
                    <span>AI Learning</span>
                </span>
            </Link>

            <button
                type="button"
                className="menu-toggle"
                aria-label="Menu"
                aria-expanded={mobileOpen}
                onClick={() => setMobileOpen((open) => !open)}
            >
                ☰
            </button>

            <ul className="menu-container">
                <li className="dropdown">
                    <button type="button" onClick={() => toggleDropdown("learn")} aria-expanded={openDropdown === "learn"}>
                        Learn
                    </button>
                    {openDropdown === "learn" && (
                        <ul className="dropdown-menu">
                            <li><Link to="/courses" onClick={closeMenu}>Courses</Link></li>
                            <li><Link to="/assessments" onClick={closeMenu}>Assessments</Link></li>
                            <li><Link to="/learningplans" onClick={closeMenu}>Learning Plans</Link></li>
                            <li><Link to="/certifications" onClick={closeMenu}>Certifications</Link></li>
                        </ul>
                    )}
                </li>

                <li className="dropdown">
                    <button type="button" onClick={() => toggleDropdown("mentorship")} aria-expanded={openDropdown === "mentorship"}>
                        Mentorship
                    </button>
                    {openDropdown === "mentorship" && (
                        <ul className="dropdown-menu">
                            <li><Link to="/mentor/find" onClick={closeMenu}>Find a Mentor</Link></li>
                            <li><Link to="/mentor/become" onClick={closeMenu}>Become a Mentor</Link></li>
                            <li><Link to="/mentor/sessions" onClick={closeMenu}>Mentor Sessions</Link></li>
                        </ul>
                    )}
                </li>

                <li className="dropdown">
                    <button type="button" onClick={() => toggleDropdown("marketplace")} aria-expanded={openDropdown === "marketplace"}>
                        Marketplace
                    </button>
                    {openDropdown === "marketplace" && (
                        <ul className="dropdown-menu">
                            <li><Link to="/marketplace" onClick={closeMenu}>Marketplace Home</Link></li>
                            <li><Link to="/marketplace/buytokens" onClick={closeMenu}>Buy Tokens</Link></li>
                            <li><Link to="/marketplace/earnrewards" onClick={closeMenu}>Earn Rewards</Link></li>
                            <li><Link to="/marketplace/mytransactions" onClick={closeMenu}>My Transactions</Link></li>
                        </ul>
                    )}
                </li>

                <li className="dropdown">
                    <button type="button" onClick={() => toggleDropdown("community")} aria-expanded={openDropdown === "community"}>
                        Community
                    </button>
                    {openDropdown === "community" && (
                        <ul className="dropdown-menu">
                            <li><Link to="/community/discussions" onClick={closeMenu}>Discussions</Link></li>
                            <li><Link to="/community/leaderboard" onClick={closeMenu}>Leaderboard</Link></li>
                            <li><Link to="/community/badges" onClick={closeMenu}>Badges</Link></li>
                            <li><Link to="/community/events" onClick={closeMenu}>Events &amp; Webinars</Link></li>
                        </ul>
                    )}
                </li>
            </ul>

            <div className="menu-right">
                <ul className="menu-container">
                    <li className="dropdown">
                        <button type="button" onClick={() => toggleDropdown("manage")} aria-expanded={openDropdown === "manage"}>
                            Manage
                        </button>
                        {openDropdown === "manage" && (
                            <ul className="dropdown-menu">
                                <li><Link to="/manage/courses" onClick={closeMenu}>Create/Edit Courses</Link></li>
                                <li><Link to="/manage/learning-plans" onClick={closeMenu}>Manage Learning Plans</Link></li>
                                <li><Link to="/manage/assessments" onClick={closeMenu}>Manage Assessments</Link></li>
                                <li><Link to="/manage/certifications" onClick={closeMenu}>Manage Certificates</Link></li>
                                <li><Link to="/manage/events" onClick={closeMenu}>Manage Events</Link></li>
                                <li><Link to="/manage/badges" onClick={closeMenu}>Manage Badges</Link></li>
                            </ul>
                        )}
                    </li>
                    <li className="dropdown">
                        <Link to="/profile" onClick={closeMenu}>My Account</Link>
                    </li>
                    <li className="dropdown">
                        <Link to="/contact" onClick={closeMenu}>Contact</Link>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default HeadMenu;
